import './bootstrap';
import '../css/app.css';
import '../css/main.scss';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';
import VueAwesomePaginate from "vue-awesome-paginate";
import "vue-awesome-paginate/dist/style.css";
import store from './store';
import * as Sentry from "@sentry/vue";
import AlertPlugin from '@/plugins/baseAlert'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import {translate} from "../utils/translationUtil";

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => {
      const defaultTitle = translate('Guldræset - Danmarks nye fantasy fodboldspil');

      if (!title) {
          return defaultTitle;
      }

      if (title.includes('Guldræset')) {
          return title;
      }

      return `${title} - Guldræset`;
  },
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue, Ziggy)
            .use(VueAwesomePaginate)
            .use(store)
            .use(AlertPlugin)
            .use(FloatingVue)
            

            const isDev = import.meta.env.MODE === 'development';

            // Setup Sentry
            Sentry.init({
              app,
              dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
              environment: import.meta.env.VITE_SENTRY_ENV,
            
              integrations: (integrations) => {
                const result = [];
            
                // Only use Vue integration in production
                if (!isDev) {
                  result.push(Sentry.vueIntegration({ app }));
                  result.push(Sentry.browserTracingIntegration());
                  result.push(Sentry.replayIntegration());
                }
            
                result.push(new Sentry.Breadcrumbs({ console: false }));
                return result;
              },
            
              tracesSampleRate: isDev ? 0 : 1.0,
              replaysSessionSampleRate: isDev ? 0 : 0.1,
              replaysOnErrorSampleRate: isDev ? 0 : 1.0,
            });

            // This is because we did not previously get the right line numbers for 
            if (isDev) {
              // Automatically capture uncaught errors
              window.addEventListener('error', (event) => {
                Sentry.captureException(event.error);
              });

              window.addEventListener('unhandledrejection', (event) => {
                Sentry.captureException(event.reason);
              });

              // Vue-specific error handler to preserve DevTools trace
              app.config.errorHandler = (err, instance, info) => {
                console.error('Vue error:', err);        // Shows clean stack trace
                Sentry.captureException(err);            // Still sent to Sentry
              };
            }
            // rehydrate/reload store before app starts
            store.commit('initiateGameplay');

        app.mount(el);

        // Dispatch the action after the Vue app is mounted
        store.dispatch('initAllCategories');

        return app;
    },
    progress: {
        color: '#4B5563',
    },
});
